import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';

import type { EditorView } from 'prosemirror-view';
import type { Observable } from 'rxjs';
import { combineLatest, of, Subject } from 'rxjs';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';

import { filterBoolean, NgTemplateAssertType, trackByValue } from '@core/common-legacy';
import type { EditorButton } from '@core/prosemirror-legacy';
import { EditorView$, StateUpdated$ } from '@core/prosemirror-legacy/angular';
import {
  IconComponent,
  ButtonComponent,
  DropdownComponent,
  DropdownWidth,
  IconButtonComponent,
  ButtonDropdownIndicatorDirective,
} from '@core/user-interface-legacy';

import { EditorButtonLabelPipe } from '../../../pipes/editor-button-label.pipe';

@Component({
  selector: 'rt-context-toolbar',
  templateUrl: './context-toolbar.component.html',
  styleUrls: ['./context-toolbar.component.less'],
  imports: [
    ButtonComponent,
    IconComponent,
    DropdownComponent,
    IconButtonComponent,
    NgTemplateOutlet,
    ButtonDropdownIndicatorDirective,
    NgTemplateAssertType,
    EditorButtonLabelPipe,
  ],
})
export class ContextToolbarComponent {
  public readonly DropdownWidth = DropdownWidth;

  public buttons$: Observable<EditorButton[]>;

  public editorView: EditorView;
  public buttons: EditorButton[];
  public buttonsState: boolean[] = [];
  public ButtonContentType: { button: EditorButton };
  public trackByValue = trackByValue;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private stateUpdated$: StateUpdated$,
    private editorView$: EditorView$,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.editorView$
      .pipe(
        filterBoolean,
        switchMap(editorView =>
          combineLatest([this.buttons$, of(editorView), this.stateUpdated$.pipe(startWith(null))]),
        ),
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe(([buttons, editorView]) => {
        this.editorView = editorView;
        this.buttons = buttons;
        this.buttonsState = buttons.map(button => button.isActive(editorView.state));
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public onButtonClick(button: EditorButton, origin: HTMLElement) {
    const { state, dispatch } = this.editorView;
    button.run(state, dispatch, origin, true);
  }
}
